var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'backbone', 'core', 'common/location'], function($, Backbone, core, location) {
  var BaseModel;
  return BaseModel = (function(_super) {

    __extends(BaseModel, _super);

    function BaseModel() {
      this.fetch = __bind(this.fetch, this);
      BaseModel.__super__.constructor.apply(this, arguments);
    }

    BaseModel.etag = null;

    BaseModel.prototype.urlRoot = function() {
      var pathRoot;
      if (this.pathRoot) {
        pathRoot = typeof this.pathRoot === 'function' ? this.pathRoot() : this.pathRoot;
        return location.apiRoot + pathRoot;
      } else {
        return location.apiRoot;
      }
    };

    BaseModel.prototype.fetch = function() {
      return BaseModel.__super__.fetch.call(this, {
        xhrFields: {
          withCredentials: true
        }
      });
    };

    BaseModel.prototype.customCall = function(url, type, data) {
      var options;
      url = this.url() + url;
      options = {
        url: url,
        type: type
      };
      if (data != null) {
        options.data = data;
        options.contentType = 'application/json; charset=UTF-8';
      }
      return (this.sync || Backbone.sync).call(this, null, this, options);
    };

    BaseModel.prototype.sync = function(method, model, options) {
      var promise,
        _this = this;
      options.xhrFields || (options.xhrFields = {});
      options.xhrFields.withCredentials = true;
      if (this.etag != null) {
        options.beforeSend = function(xhr) {
          return xhr.setRequestHeader('ETag', _this.etag);
        };
      }
      promise = Backbone.sync(method, model, options);
      return promise != null ? promise.done(function() {
        return _this.etag = typeof promise.getResponseHeader === "function" ? promise.getResponseHeader('ETag') : void 0;
      }) : void 0;
    };

    return BaseModel;

  })(Backbone.Model);
});
